var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"body-2",attrs:{"value":_vm.value,"name":_vm.metadata.name,"validate-on-blur":"","aria-label":_vm.formattedAriaLabel(
        _vm.metadata[("description" + (this.upperLocale))],
        _vm.required
    ),"label":_vm.formattedLabel(
        _vm.metadata[("description" + (this.upperLocale))],
        _vm.required
    ),"id":_vm.metadata.name},on:{"change":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }